@use "../../styles/breakpoint" as *;

:global(html, body) {
    margin: 0;
    padding: 0;
}

.gtmIframe {
    display: none;
    visibility: hidden;
}

.main {
    overflow-x: hidden;
}

.container {
    composes: container from "../../styles/composable/layout.module.css";
}

.header {
    background-color: var(--alabaster);

    .container {
        display: flex;
        padding: 36px 0;
        justify-content: space-between;

        @media ($above-mobile) and ($below-tablet) {
            flex-wrap: wrap;
            justify-content: center;
        }

        @media ($below-mobile) {
            &::before {
                content: "";
                flex: 1;
            }
        }
    }
}

.logo {
    --logo-width: 318px;

    width: var(--logo-width);

    @media ($below-mobile) {
        --logo-width: 212px;
    }

    @media ($below-tiny) {
        --logo-width: 183px;
    }
}

.footer {
    background-color: var(--alabaster);
    color: var(--ironside);
    padding: 47px 0;

    .container {
        border-top: 1px solid var(--silver);
        padding-top: 24px;
    }
}

.link {
    color: var(--blue);
    padding: 0 0.25rem;
}
